
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-quiz-options',
  templateUrl: './quiz-options.component.html',
  styleUrls: ['./quiz-options.component.scss']
})
export class QuizOptionsComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<QuizOptionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  /**
   * Close modal
   * */
  onNoClick(): void {
    this.dialogRef.close();
  }

}


